import { memo } from 'react';

import { ComponentContextProps, merge, useComponent } from '@/components';

export type PipeProps = Partial<ComponentContextProps>;

const IPipe = ({ variant }: PipeProps) => {
  const context = useComponent({ variant });

  /* prettier-ignore */
  const styles = [
    'rounded-full',
    'min-w-1',
    'max-w-1',
  ];

  /* prettier-ignore */
  const successStyles = [
    'bg-success-500'
  ];

  /* prettier-ignore */
  const warningStyles = [
    'bg-warning-500'
  ];

  /* prettier-ignore */
  const errorStyles = [
    'bg-error-500'
  ];

  return (
    <div
      className={merge(
        styles,
        context.variant === 'success' && successStyles,
        context.variant === 'warning' && warningStyles,
        context.variant === 'error' && errorStyles
      )}
    />
  );
};

export const Pipe = memo(IPipe) as typeof IPipe;
